export const mentorsData = [
  {
    id: 1,
    name: 'Sandra Ogbuso',
    title: 'Business development consultant Start-up coach /Entrepreneur',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/1001633984-01+-+Sandra+Ogbuso.jpeg',
    link: '/',
  },
  {
    id: 2,
    name: 'Divine Brawndy',
    title: 'Business Consultant/IT Specialist ',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/2025-06-07-23-37-22-469_restored+(2)+(1)+(2)~2+-+Brawndy+Divine.jpg',
    link: '/',
  },
  {
    id: 3,
    name: 'Nancy Amaku',
    title: 'Pastrypreneur',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/6f87f49c-9e01-4f86-8c88-e93baec95ae0+-+Chef+Nahnah.jpeg',
    link: '/',
  },
  {
    id: 4,
    name: 'Deborah Akerele',
    title:
      'Author/ Founder Valouree Foundation/ Co-founder Read Africa Heal Africa.',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/IMG_20250924_111746+-+Deborah+Akerele.JPG',
    link: '/',
  },
  {
    id: 5,
    name: 'Jessica Okoli',
    title: 'Entrepreneur and Business Coach/ Mentor',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/IMG-20250923-WA0049+-+okoli+jessica+(Successbox+Limited).jpg',
    link: '/',
  },
  {
    id: 6,
    name: 'Kemi Daramola',
    title: 'Beauty Entrepreneur',
    image:
      'https://shecluded-medias.s3.us-east-2.amazonaws.com/Untitled+design+-+Kemi+Daramola.png',
    link: '/',
  },
  // {
  //   id: 7,
  //   name: 'Kemi Daramola',
  //   title: 'CEO of Sheywa Beauty',
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_7.png',
  //   link: '/',
  // },
  // {
  //   id: 8,
  //   name: 'Peremoboere Agbogidi',
  //   title: 'Founder of Lady Pere Dev Hub',
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_8.jpg',
  //   link: '/',
  // },
  // {
  //   id: 9,
  //   name: 'Mercedes Njoku',
  //   title: "Founder of Ivan's Peanut Butter",
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_9.jpg',
  //   link: '/',
  // },
  // {
  //   id: 10,
  //   name: 'Nwanne Nwonwu',
  //   title: 'Founder of The Talent Pipeline Company',
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_10.jpg',
  //   link: '/',
  // },
  // {
  //   id: 11,
  //   name: 'Nwanne Nwonwu',
  //   title: 'Founder of The Palms Tutors',
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_11.JPG',
  //   link: '/',
  // },
  // {
  //   id: 12,
  //   name: 'Oluchukwu Chiadika',
  //   title: 'Founder of Your Personal Finance Girl',
  //   image:
  //     'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor_profile_12.jpg',
  //   link: 'https://www.instagram.com/personalfinancegirl/',
  // },
  // {
  //   id: 13,
  //   name: 'Princess Edokpayi',
  //   title: 'Chief Operating Officer at Spurt!',
  //   image: 'https://shecluded-medias.s3.us-east-2.amazonaws.com/mentor-13.jpeg',
  //   link: '/',
  // },
];
